// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"377":"play","485":"game","980":"leaderboard"}[chunkId] + "." + {"377":"6b18248e","485":"482e75c7","980":"5b57c09b"}[chunkId] + ".css";
};